import { co2 } from './common';

export default {
  //Denmark
  'consumption.co2': `${co2} ved blandet kørsel`,
  'consumption.energy': 'Energiforbrug ved blandet kørsel',
  'consumption.fuel': 'Brændstofforbrug ved blandet kørsel',
  'footnotes.local': '',
  'footnotes.wltp': `De oplyste værdier er beregnet i overensstemmelse med den foreskrevne målemetode. Der er tale om „WLTP-${co2}-værdier“ i henhold til art. 2 nr. 3 i gennemførelsesforordning (EU) 2017/1153. Brændstofforbrugsværdierne er beregnet på grundlag af disse værdier. Strømforbruget er beregnet på grundlag af forordningen 683/2008/EF. Angivelserne er ikke baseret på en enkelt bil og indgår ikke i produktomfanget, men er udelukkende beregnet til sammenligning mellem forskellige biltyper. Værdierne varierer afhængigt af det valgte ekstraudstyr.`,
  'footnotes.nedc': '',
  'footnotes.emissions.appendix': `Kontakt din autoriserede Mercedes-Benz forhandler for yderligere information om officielle forbrugstal og ${co2}-emissioner for nye biler.`,
  'search.input.label': 'Din søgning / OnlineCode Configurator',
  'search.results': 'Intet resultat fundet. | {count} Søgeresultat | {count} Søgeresultat',
  'search.result.buy-online': 'Buy Online',
  'search.results.count': '{count} Søgeresultat',
  'search.results.backup': 'Intet match fundet. Se relateret materiale:',
  'search.results.none.summary':
    'Der er ingen søgeresultater til gengængelige for din søgning. Prøv igen med en anden søgning.',
  'search.show-more': 'Vis mere',
  'search.unavailable': 'Søgning er ikke tilgængelig lige nu.',
  'search.result.new': 'Ny',
  'input.placeholder': 'Din søgning / OnlineCode Configurator',

  'suggestions.all_search_results': 'Alle søgeresultater',
  'suggestions.all_search_results_for': 'Vis alle resultater for',
  'suggestions.in': 'i',
  // <--------------  end this

  all: 'Alle',
  UCOS: 'Brugte biler onlinebutik',
  PASSENGER_CARS: 'Personbil',
  VANS: 'MPV',
  NCOS: 'Nye biler onlinebutik',
  VIDEO: 'Videoer',
  DEALER_LOCATOR: 'Forhandlersøgning',
  CONFIGURATOR: 'Konfigurér din bil',
  TEST_DRIVE: 'Prøvetur',
  VEHICLE_SEARCH: 'Søgning efter brugt bil',
  COLLECT: 'Collection & tilbehør',
  CONNECT: 'Mercedes me Store',
  ACCESSORIES: 'Biltilbehør',

  'search.result.consumption': 'Forbrug',
  'watch.video': 'Se videoen',
  'input.recently': 'Søgt for nylig',
  'input.help.title': 'Hvad skal du kigge efter?',
  'input.help.text':
    'Søg ved hjælp af biltyper, modeller, konfigurationskoder eller efter tilbehør, andre produkter og oplysninger',

  'search.result.list': 'Liste',
  'search.result.grid': 'Gitter',

  // No results found
  'support.check': 'Tjek venligst for tastefejl, eller prøv igen med et andet udtryk.',
  'support.no.results': 'Der er ingen tilgængelige søgeresultater for denne søgeterm.',
  'support.no.results.term': 'Ingen resultater fundet',
  'support.chat': 'Kan du ikke finde det, du leder efter? Brug venligst vores',
  'support.chat.with.us': 'online-chat-support',
};
